import React from 'react';
import Text from 'fe-design-base/atoms/Text';
import Link from 'fe-design-base/molecules/Link/Link';

import { toI18n } from 'util/i18n';

import Footer from '../components/Footer';
import Header from '../components/Header';
import PastDueDialogBox from '../components/PastDueDialogBox';

import { AfterGracePeriodViewProps } from './types';
import { useHandleOnClickSecondary } from './useHandleOnClickSecondary';

const secondaryCtaText = toI18n(
  'past_due_subscription.dialog.after_grace_period.secondary_cta'
);

export const AfterGracePeriodView = ({
  noChange,
  isLoading,
  setIsLoading,
  onClickPrimary,
  primaryCtaText,
  primaryUxElement,
  previousTierName,
  setCurrentViewKey,
  setDecidedToStayOnBasic,
}: AfterGracePeriodViewProps) => {
  const handleOnClickSecondary = useHandleOnClickSecondary({
    noChange,
    setIsLoading,
    setCurrentViewKey,
    setDecidedToStayOnBasic,
  });

  return (
    <PastDueDialogBox>
      <Header
        titleI18n="past_due_subscription.dialog.after_grace_period.title"
        iconColor="orange300"
        iconName="Warning"
      />
      <Text
        i18n="past_due_subscription.dialog.after_grace_period.description_pre_text"
        i18nProps={{
          previousTierName,
        }}
        asHTML
      >
        &nbsp;
        <Link href="/help" target="_blank">
          {toI18n(
            'past_due_subscription.dialog.after_grace_period.description_link_text'
          )}
        </Link>
        &nbsp;
        {toI18n(
          'past_due_subscription.dialog.after_grace_period.description_post_text'
        )}
      </Text>

      <Footer
        isLoading={isLoading}
        onClickPrimary={onClickPrimary}
        primaryCtaText={primaryCtaText}
        primaryUxElement={primaryUxElement}
        secondaryCtaText={secondaryCtaText}
        secondaryUxElement="stay-on-basic-cta"
        onClickSecondary={handleOnClickSecondary}
      />
    </PastDueDialogBox>
  );
};

export default AfterGracePeriodView;
